/* eslint-disable react/prop-types */
import * as React from 'react';

import styles from './modalcontainer.scss';
import '../common/customStyles.scss';
import {
    IBasketModalData,
    IProps,
    IAMSResponseData,
    ICrossSell,
    IBasketModalDataForLogoCreator,
    IBricksListItem,
} from '../../types/properties';
import axios from 'axios';
import SelfServiceBanModal from '../selfServiceBanModal/selfServiceBanModal';
import MaxAmountModal from '../maxAmountModal/maxAmountModal';
import BasketModal from '../basketmodal/basketmodal';
import SelfServiceBanForPrivateModal from '../selfServiceBanForPrivateModal/selfServiceBanForPrivateModal';
import { ScrollLock } from '../helper/scrollLock';
import { ActionHelper } from '../helper/ActionHelper';
import { EsAppHelper } from '../helper/esAppHelper';
import { TrackingHelper, ArticleTrackingData, PiwikArticleTrackingData } from '@escid-espp1/helpers'
import { IActionControlEventData } from '../action-control';
import { BasketFlexibleSetItem } from '../types/api/basket';
import * as routerHelper from '../helper/router-helper';

enum BasketErrorCodes {
    MaxAmount = 'MaxItemQuantityPerOrderExceeded',
    SelfServiceBanNotAllowedForPrivateCustomer = 'SelfServiceBanNotAllowedForPrivateCustomer',
    SelfServiceBanNotConfirmed = 'SelfServiceBanNotConfirmed'
}

const basketModalContainerId = 'basket_modal_container';

interface IState {
    showModal: boolean;
    modalContent: JSX.Element;
    priceMode: string;
    isLoading: boolean;
}

export default class ModalContainer extends React.Component<IProps, IState> {
    private addItemEndpoint = 'api/basket/basket/add-item'
    private flexibleSetBasketEndpoint = 'api/basket/flexibleSets'
    private AMSEndpoint = 'api/articlemetric/crosssellingteaser?salesArticleVariantKey=';
    private readonly scrollLock = new ScrollLock(basketModalContainerId);
    private readonly actionHelper = ActionHelper.instance;
    public readonly esAppHelper = new EsAppHelper();
    private readonly apiPrefix;
    private previouslySelectedElement: Element;
    private trackingHelper: TrackingHelper;

    constructor(props: IProps) {
        super(props);
        this.apiPrefix = props.magicLink;

        this.state = {
            showModal: false,
            modalContent: null,
            priceMode: this.getPriceMode(),
            isLoading: false,
        }

        this.handleModalClose = this.handleModalClose.bind(this);

        this.trackingHelper = new TrackingHelper(props.hasPiwikTracking,
            props.hasMetaTracking, props.hasTiktokTracking, props.enableClientLogging, '', null);
    }

    componentDidMount() {
        if (typeof window !== 'undefined' && window.shell) {
            window.shell.subscribeTo(
                'ESPP.BasketModal.Open',
                payload => {
                    this.handleBasketModalOpen(payload)
                },
                'BasketModal'
            );

            window.shell.subscribeTo(
                'ESPP.BasketModal.Open.LogoCreator',
                payload => {
                    this.handleBasketModalOpenForLogoCreator(payload)
                },
                'BasketModal'
            );

            window.shell.subscribeTo(
                'PriceModeChanged',
                payload => {
                    if (typeof payload === 'string' && payload.length > 0)
                        this.setState({ priceMode: payload });
                },
                'BasketModal'
            );

            window.shell.subscribeTo(
                'modal.closed',
                payload => {
                    if (this.state.showModal && payload === 'quickOrderModal-addToBasket')
                        this.scrollLock.lock();
                },
                'basketModal'
            );
        }
    }

    private handleBasketModalOpen(data: IBasketModalData) {
        if (!this.state.isLoading) {
            this.setState({ isLoading: true });
            if (this.props.enableFlexibleSetPage && data.flexSetId) {
                this.addFlexibleSetToBasket(data).finally(() => {
                    this.setState({ isLoading: false })
                });
            } else {
                this.addToBasket(data).finally(() => {
                    this.setState({ isLoading: false })
                });
            }

            this.previouslySelectedElement = document.activeElement;
        }
    }

    private handleBasketModalOpenForLogoCreator(data: IBasketModalDataForLogoCreator) {
        if (!this.state.isLoading) {
            this.setState({ isLoading: true });
            this.openForLogoCreator(data);
        }
    }

    private getPriceMode(): string {
        if (this.props.priceMode && this.props.priceMode.length > 0)
            return this.props.priceMode
        else if (typeof document !== 'undefined') {
            const html = document.getElementsByTagName('html')[0];
            if (html.classList.contains('current-pricemode-gross'))
                return 'Gross';
            else if (html.classList.contains('current-pricemode-net'))
                return 'Net';
            else
                return '';
        } else
            return '';
    }

    private confirmSelfServiceBan(data: IBasketModalData) {
        if (!this.state.isLoading) {
            this.setState({ isLoading: true });
            this.addToBasket(data, true).finally(() => {
                this.setState({ isLoading: false })
            });
        }
    }

    private willShowBasketModal(isSuccessAdd: boolean) {
        if (typeof window != 'undefined' && window.shell)
            window.shell.publishTo(
                'ESPP.BasketModal.WillOpen',
                {
                    successAdd: isSuccessAdd
                }
            );
        window.shell.publishTo('ESPP.OrderModal.Close', null);
    }

    private failShowBasketModal(reason) {
        if (typeof window != 'undefined' && window.shell) {
            let error = null;
            if (reason)
                error = { error: reason };

            window.shell.publishTo(
                'ESPP.BasketModal.Failed', error);
        }
    }

    private handleModalClose() {
        window.shell.tabNav.focus(this.previouslySelectedElement);

        if (this.props.isEsApp)
            this.esAppHelper.navigationWheel.updateWheel(this.apiPrefix);

        this.setState({ showModal: false });

        this.scrollLock.unlock();
        this.esAppHelper.navigationWheel.show();

        window.shell.publishTo(
            'ESPP.BasketModal.Close', null
        );
    }

    private buildModal(responseData, basketModalData: IBasketModalData, amsResponse?: IAMSResponseData) {
        setTimeout(() => this.scrollLock.lock(basketModalData.scrollPosition), 200);
        setTimeout(() => this.esAppHelper.navigationWheel.hide(), 200);

        if (responseData.successful === true) {
            this.setState({
                modalContent:
                    <BasketModal
                        onIsOpenChange={this.handleModalClose}
                        data={basketModalData}
                        localization={this.props.localization}
                        priceMode={this.state.priceMode}
                        amsResponse={amsResponse}
                        cdnHost={this.props.cdnHost}
                        enableFlexibleSetPage={this.props.enableFlexibleSetPage}
                        isPreview={this.props.isPreview}
                    />
            });
            this.willShowBasketModal(true);
            this.setState({ showModal: true });
            this.reloadBasketFlyout();

            const actionEventData: IActionControlEventData = {
                actionSubject: basketModalData.quantity + '/' + basketModalData.masterArticleNo + '/' + basketModalData.salesVariantKey,
                actionType: 'AddToBasket'
            };

            this.actionHelper.trackActionControlEventCallback(actionEventData);
        }
        else {
            if (responseData.errorCode == BasketErrorCodes.MaxAmount) {
                this.setState({
                    modalContent: <MaxAmountModal
                        onIsOpenChange={this.handleModalClose}
                        errorMessage={responseData.errorMessage}
                        maxQuantityOrderTitle={this.props.localization.maxQuantityOrderTitle} />
                });
                this.willShowBasketModal(false);
                this.setState({ showModal: true });
            }
            if (responseData.errorCode == BasketErrorCodes.SelfServiceBanNotConfirmed) {
                this.setState({
                    modalContent: <SelfServiceBanModal onIsOpenChange={this.handleModalClose}
                        onConfirm={() => this.confirmSelfServiceBan(basketModalData)} localization={this.props.localization} />
                });
                this.willShowBasketModal(false);
                this.setState({ showModal: true });
            }
            if (responseData.errorCode == BasketErrorCodes.SelfServiceBanNotAllowedForPrivateCustomer) {
                this.setState({
                    modalContent: <SelfServiceBanForPrivateModal onIsOpenChange={this.handleModalClose}
                        localization={this.props.localization} />
                });
                this.willShowBasketModal(false);
                this.setState({ showModal: true });
            }
        }
    }

    private buildModelForLogoCreator(basketModalData: IBasketModalDataForLogoCreator, amsResponse?: IAMSResponseData) {
        this.scrollLock.lock();
        setTimeout(() => this.esAppHelper.navigationWheel.hide(), 200);

        this.setState({
            modalContent:
                <BasketModal
                    onIsOpenChange={this.handleModalClose}
                    data={null}
                    dataForLC={basketModalData}
                    localization={this.props.localization}
                    priceMode={this.state.priceMode}
                    amsResponse={amsResponse}
                    cdnHost={this.props.cdnHost}
                    enableFlexibleSetPage={this.props.enableFlexibleSetPage}
                    isPreview={this.props.isPreview}
                />
        });
        this.willShowBasketModal(true);
        this.setState({ showModal: true });
    }

    private trackAddToCart(data: IBasketModalData) {
        const price = {
            grossValue: Number(data.grossPrice),
            netValue: Number(data.netPrice),
        }
        const scaledPrices = data.scalePrice ? [{
            grossValue: Number(data.scalePrice.grossValue),
            netValue: Number(data.scalePrice.netValue),
        }] : null;

        const trackingData: PiwikArticleTrackingData = {
            id: data.flexSetId || data.salesVariantKey,
            name: data.title,
            price: price,
            scaledPrices: scaledPrices,
            brand: data.isStraussBrand ? 'Strauss' : 'other Brand',
            category: data.nativeNavKeyPath,
            currencyCode: data.currencyISO,
            variantId: data.basketItemId || data.salesVariantKey,
            colorCode: data.color,
            colorName: data.colorName,
            sizeName: data.size,
            modelCode: data.model,
            modelName: data.modelLabel,
            masterArticleNo: data.masterArticleNo,
            productRecommendationFragment: data.productRecommendationFragment,
            productRecommendationModel: data.productRecommendationModel,
            productRecommendationTileIndex: data.productRecommendationTileIndex,
        };


        const piwikTrackingData = { ...trackingData };
        piwikTrackingData.id = data.flexSetId || data.salesArticleNo;

        this.trackingHelper.setItemOrigin(data.itemOrigin);

        this.trackingHelper.piwikTrackAddToCart(piwikTrackingData, data.quantity);
        this.trackingHelper.metaTrackAddToCart(trackingData, data.quantity);
        this.trackingHelper.tiktokTrackAddToCart(trackingData, data.quantity);
    }

    private trackAddedArticleFromLC(data: IBasketModalDataForLogoCreator) {
        let reportingPrice = data.reporting.price.value;
        let totalGrossValue = 0;
        let totalNetValue = 0;
        let totalQuantity = 0;

        this.trackingHelper.setItemOrigin(data.itemOrigin);

        data.sizesWithPrice.forEach(size => {
            const keys = size.savKey.split('-');
            const price = { netValue: size.netPrice, grossValue: size.grossPrice };

            const trackingData: ArticleTrackingData = {
                id: keys[0],
                name: data.title,
                price: price,
                brand: data.isStraussBrand ? 'Strauss' : 'other Brand',
                category: data.nativeNavKeyPath,
                currencyCode: data.reporting.price.currency,
                variantId: size.savKey,
                colorCode: data.color,
                colorName: data.colorName,
                sizeCode: Array.isArray(data.size) ? data.size[0] : data.size,
                sizeName: size.label,
                modelCode: data.model,
                modelName: data.modelLabel,
                masterArticleNo: String(data.masterArticleNumber),
                customizations: data.reporting.customizations,
                reportingPrice,
            };

            this.trackingHelper.piwikTrackAddToCart(trackingData, size.quantity);

            totalGrossValue += size.grossPrice * size.quantity;
            totalNetValue += size.netPrice * size.quantity;
            totalQuantity += size.quantity;
        });

        reportingPrice = data.reporting.price.value * totalQuantity;
        totalGrossValue += reportingPrice;
        totalNetValue += reportingPrice;

        const contents = data.sizesWithPrice.map(size => {
            return { id: size.savKey, quantity: size.quantity };
        });

        const trackingData: ArticleTrackingData = {
            id: contents[0].id.split('-')[0],
            name: data.title,
            brand: data.isStraussBrand ? 'Strauss' : 'other Brand',
            category: data.nativeNavKeyPath,
            price: { netValue: totalNetValue, grossValue: totalGrossValue },
            currencyCode: data.reporting.price.currency,
            variantId: contents[0].id,
            contents,
        }

        const quantity = Array.isArray(data.quantity) ? data.quantity[0] : data.quantity;

        this.trackingHelper.metaTrackAddToCart(trackingData, quantity);
        this.trackingHelper.tiktokTrackAddToCart(trackingData, quantity);
    }

    private async addToBasket(data: IBasketModalData, selfServiceBan = false) {
        const finalEndpoint = this.apiPrefix
            + this.AMSEndpoint + data.salesVariantKey;
        const basketPromise = axios.post(this.apiPrefix + this.addItemEndpoint, {
            salesArticleVariantKey: data.salesVariantKey,
            quantity: data.quantity,
            selfServiceBanConfirmed: selfServiceBan,
            itemOrigin: data.itemOrigin,
            nativeNavKeyPath: data.nativeNavKeyPath,
        });
        const AMSPromise = axios.get(`${finalEndpoint}`, { timeout: 3000 });

        if (!selfServiceBan) {
            try {
                const [addToBasketResponse, AMSResponse] = await Promise.allSettled([
                    basketPromise, AMSPromise]);

                if (addToBasketResponse.status === 'fulfilled') {
                    const AMSData: IAMSResponseData = AMSResponse.status === 'fulfilled' ? {
                        crossSellings: AMSResponse.value.data.articles,
                        rootCategory: AMSResponse.value.data.rootCategoryNavigationKey,
                    } : null;
                    if (AMSData != null) {
                        const validCrossSellUnits: ICrossSell[] = AMSData.crossSellings?.filter(
                            unit => !unit.detailsPageLink.endsWith(location.hostname + '/')
                        );
                        AMSData.crossSellings = validCrossSellUnits;
                        AMSData.crossSellings.forEach(crossSelling => { crossSelling.isGlobal = this.props.isGlobal });
                    }
                    this.trackAddToCart(data);
                    this.buildModal(addToBasketResponse.value.data, data, AMSData);
                } else {
                    this.failShowBasketModal(addToBasketResponse.reason);
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        } else {
            try {
                const addToBasketResponse = await basketPromise;
                this.buildModal(addToBasketResponse.data, data);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        }
    }

    private async addFlexibleSetToBasket(data: IBasketModalData, selfServiceBan = false) {
        const addToBasketEndpoint = this.apiPrefix + this.flexibleSetBasketEndpoint;
        const bricksList: IBricksListItem[] = data.brickSelections.map((item) => {
            return {
                positionNo: item.positionNo,
                brickNo: item.brickNo,
                masterArticleNo: item.masterArticleNo,
                savK: item.salesArticleVariantKey.toString(),
            }
        })
        const baseRequestBody: Omit<BasketFlexibleSetItem, 'itemOrigin' | 'basketItemId'> = {
            /*
            * PUT request will create a new item in the basket if it's no longer there
            * and if 'fsCode' parameter is presented in the request body.
            */
            fsCode: data.flexSetId,
            amount: data.quantity,
            bricksList: bricksList,
        }

        const basketPromise: Promise<any> = data.basketItemId
            ? (function UpdateOrCreateItemInBasket() {
                const requestBody: BasketFlexibleSetItem = {
                    ...baseRequestBody,
                    basketItemId: data.basketItemId,
                    itemOrigin: 'basket'
                }
                return axios.put(addToBasketEndpoint, requestBody);
            })()
            : (function CreateItemInBasket() {
                const requestBody: BasketFlexibleSetItem = {
                    ...baseRequestBody,
                    itemOrigin: data.itemOrigin
                }
                return axios.post(addToBasketEndpoint, requestBody);
            })();

        if (!selfServiceBan) {
            try {
                const [addToBasketResponse] = await Promise.allSettled([basketPromise]);

                if (addToBasketResponse.status === 'fulfilled') {
                    const newBasketItemId: string = addToBasketResponse.value.data?.basketItemId;
                    if (newBasketItemId) {
                        routerHelper.UpdateQueryParameter('BasketItemId', newBasketItemId);

                        window.shell?.publishTo('ESPP.BasketModal.BasketItemIdChange', {
                            basketItemId: newBasketItemId
                        })
                    }
                    this.trackAddToCart(data);
                    this.buildModal(addToBasketResponse.value.data, data);
                } else {
                    this.failShowBasketModal(addToBasketResponse.reason);
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        } else {
            try {
                const addToBasketResponse = await basketPromise;
                this.buildModal(addToBasketResponse.data, data);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }
        }
    }

    private openForLogoCreator(data: IBasketModalDataForLogoCreator) {
        const finalEndpoint = this.apiPrefix
            + this.AMSEndpoint + data.exampleSalesVariantKey;
        axios.get(`${finalEndpoint}`, { timeout: 3000 }).then((response) => {
            const AMSData: IAMSResponseData = response.status === 200 ? {
                crossSellings: response.data.articles,
                rootCategory: response.data.rootCategoryNavigationKey,
            } : null;
            if (AMSData != null) {
                const validCrossSellUnits: ICrossSell[] = AMSData.crossSellings?.filter(
                    unit => !unit.detailsPageLink.endsWith(location.hostname + '/')
                );
                AMSData.crossSellings = validCrossSellUnits;
                AMSData.crossSellings.forEach(crossSelling => { crossSelling.isGlobal = this.props.isGlobal });
            }
            this.buildModelForLogoCreator(data, AMSData);
            if (data.sizesWithPrice && data.sizesWithPrice.length > 0) {
                this.trackAddedArticleFromLC(data);
            }
        }).finally(() => {
            this.setState({ isLoading: false })
        });
    }

    private reloadBasketFlyout() {
        window.shell.publishTo('ESSA.BasketFlyout.BasketItemCountChanged', null);
    }

    render() {
        return (
            <div id={basketModalContainerId} data-testid='basket_modal_container'
              data-semantic-id='basket_modal_container' className={styles.basket_modal_container}>
                {this.state.showModal && this.state.modalContent}
            </div>
        )
    }
}

